import { useState } from 'react';
import UploadBackDrop from './UploadBackDrop';
import { useParams } from 'react-router-dom';
import { blockMasterSchema } from '../Notes';
import { getRandomUid } from 'utilities/uuid.service';
import { AppButton } from 'components';
import useManageTopicRevision from 'hooks/API/useManageTopicRevision';
import useGetRevisionNotes from 'hooks/API/GET/useGetRevisionNotes';
import RevisionNotesList from './RevisionList';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import { notifier } from 'components/Toaster';

function TopicRevisionTab() {
  const { topicID } = useParams();
  const [blocks, setBlocks] = useState([]);
  const [openUploadModal, toggleUploadModal] = useState({
    currentBlock: '',
    block: null,
  });

  const actionsConfig = {
    open: false,
    data: {},
    Header: null,
    Body: null,
    isDeleteOperation: false,
  };
  const [actions, setActions] = useState({ ...actionsConfig });

  const { mutate } = useManageTopicRevision({ topicId: topicID });
  const { data } = useGetRevisionNotes({ topicId: topicID, enabled: !!topicID });

  const hasRevisionNote = data?.data?.length > 0;

  /*----------------Image Upload------------------*/

  const updateBlock = (obj = {}, block) => {
    if (!obj.currentBlock) return;

    setBlocks((prev) =>
      prev.map((x) => {
        if (x.id === block.id) {
          return { ...x, ...obj };
        }
        return x;
      })
    );
  };

  /*------------------Revision Note - Add & Update----------------*/

  const manageTopicRevision = () => {
    if (!blocks.length) return;

    const block = blocks[0]; // only one allowed

    if (hasRevisionNote) {
      const existingNote = data.data[0];

      mutate(
        {
          type: 'UPDATE',
          revisionId: existingNote._id,
          data: {
            image: block.assetUri,
            caption: block.caption,
          },
        },
        {
          onSuccess: (data) => {
            let message = data?.data?.data?.message;
            notifier.success(message);
            handleClearData();
          },
          onError: (err) => {
            let message = err?.response?.data?.message;
            notifier.err(message);
          },
        }
      );
    } else {
      mutate(
        {
          image: block.assetUri,
          caption: block.caption,
        },
        {
          onSuccess: (data) => {
            let message = data?.data?.data?.message;
            notifier.success(message);
            handleClearData();
          },
          onError: (err) => {
            let message = err?.response?.data?.message;
            notifier.err(message);
          },
        }
      );
    }
  };

  /*--------------------Delete*-------------------*/

  function handleDelete(note) {
    setActions({
      open: true,
      data: { revisionId: note._id },
      Header: 'Delete Revison Note',
      Body: `Are you sure you want to delete revision note"?`,
      isDeleteOperation: true,
    });
  }

  function handleDeleteConfirm() {
    mutate(
      {
        type: 'DELETE',
        revisionId: actions.data.revisionId,
      },
      {
        onSuccess: (data) => {
          let message = data?.data?.data?.message;
          notifier.success(message);
        },
        onError: (err) => {
          let message = err?.response?.data?.message;
          notifier.err(message);
        },
      }
    );
    setActions({ ...actionsConfig });
  }

  /*------------Cancel & Clear-------------*/

  const handleCancel = () => {
    setBlocks([]);
  };

  const handleClearData = () => {
    setBlocks([]);
  };

  return (
    <>
      <BasicDelete
        open={actions.open}
        closeModal={() => setActions({ ...actionsConfig })}
        Header={actions.Header}
        Body={actions.Body}
        handleConfirmation={handleDeleteConfirm}
      />
      <div className="container ninty_percent_width p-0 relative">
        {/* Upload Modal */}
        {openUploadModal.currentBlock && (
          <UploadBackDrop
            data={{ openUploadModal }}
            closeModal={() => {
              toggleUploadModal({ currentBlock: '', block: null });
            }}
            handleSave={(obj, block) => {
              // EDIT existing revision note (store locally only)
              if (block?.isEdit) {
                setBlocks((prev) =>
                  prev.map((x) => (x.revisionId === block.revisionId ? { ...x, ...obj } : x))
                );

                toggleUploadModal({ currentBlock: '', block: null });
                return;
              }

              // EDIT local block
              if (block) {
                updateBlock(obj, block);
                toggleUploadModal({ currentBlock: '', block: null });
                return;
              }

              // NEW block
              setBlocks((prev) =>
                prev.concat({
                  ...blockMasterSchema,
                  id: getRandomUid(),
                  ...obj,
                })
              );

              toggleUploadModal({ currentBlock: '', block: null });
            }}
          />
        )}

        {/* Heading */}
        <div className="row">
          <div className="col-12 publishheader">
            <h2 className="prime-head p-0 boldtitle">Add Revision Note</h2>
          </div>
        </div>

        {/* Image Blocks */}
        <div className="row mt-4">
          {blocks.map((block) => (
            <div
              key={block.id}
              className="col-12 __image_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center"
            >
              <div className="ratio ratio-21x9">
                <img src={block.assetUrl} alt="uploaded" />
              </div>
              <div className="___icon_label_button"></div>
            </div>
          ))}
        </div>

        {/* Add Image Button */}
        <div className="row mt-4">
          <div className="col-12">
            <label className="label d-block">Add image *</label>
            <AppButton
              variantClass="btn btn-primary"
              onClick={() => toggleUploadModal({ currentBlock: 'image', block: null })}
            >
              {hasRevisionNote ? 'Update Image' : 'Add Image'}
            </AppButton>
          </div>
        </div>
        {blocks.length > 0 && (
          <div className="row mt-5 btnsubmitmain __flex-j-c-center">
            <div className="btnTab-foot">
              <button type="button" className="btn btn-primary" onClick={handleCancel}>
                Cancel
              </button>
            </div>
            <div className="col-3 btnTab-foot">
              <button
                type="button"
                className="btn-right-content save"
                onClick={() => {
                  manageTopicRevision();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        )}

        <hr className="divider" />

        <RevisionNotesList data={data?.data || []} handleDelete={handleDelete} />
      </div>
    </>
  );
}

export default TopicRevisionTab;
